import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plug, CheckCircle2, Circle } from "lucide-react";

const CAT_ORDER = ["AI", "Storage", "Wallet", "Chain", "Pad", "Treasury", "Social", "Payments", "Infra"];

export default function Integrations() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/system/integrations").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="p-8 text-dust">Loading integrations…</div>;

  const byCat = {};
  data.integrations.forEach((i) => { (byCat[i.category] = byCat[i.category] || []).push(i); });
  const cats = CAT_ORDER.filter((c) => byCat[c]);

  return (
    <div className="mx-auto max-w-4xl px-6 py-8 lg:px-10" data-testid="integrations-page">
      <div className="mb-6 flex items-center gap-3">
        <Plug className="text-juice" size={22} />
        <div>
          <h1 className="text-2xl font-bold text-cream">Integrations</h1>
          <p className="text-sm text-dust">{data.live} of {data.total} live. Empty ones run SIMULATED until you paste keys in backend/.env.</p>
        </div>
      </div>

      <div className="space-y-6">
        {cats.map((cat) => (
          <div key={cat}>
            <h2 className="mb-2 text-xs font-semibold uppercase tracking-wider text-dust">{cat}</h2>
            <div className="overflow-hidden rounded-2xl border border-line bg-surface">
              {byCat[cat].map((i) => (
                <div key={i.key} className="flex items-center gap-3 border-b border-line/60 px-5 py-3.5 last:border-0" data-testid={`integration-${i.key}`}>
                  {i.mode === "live" ? <CheckCircle2 size={16} className="text-pulp" /> : <Circle size={16} className="text-dust/40" />}
                  <div className="min-w-0 flex-1">
                    <p className="text-sm text-cream">{i.name}</p>
                    {i.missing.length > 0 && (
                      <p className="mt-0.5 font-mono text-[11px] text-dust">needs: {i.missing.join(", ")}</p>
                    )}
                  </div>
                  <span className={`rounded-full px-2.5 py-0.5 text-[10px] uppercase tracking-wide ${i.mode === "live" ? "bg-pulp/15 text-pulp" : "bg-ai/15 text-ai"}`}>{i.mode}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <p className="mt-6 text-xs text-dust">Instance {data.instance.slice(0, 8)} · background workers {data.worker_enabled ? "enabled (single-leader)" : "disabled on this pod"}.</p>
    </div>
  );
}
